module.exports = __webpack_public_path__ + "static/img/weather68.b221ac1f.png";